import React, { Component } from 'react';
import DaumPostcode from 'react-daum-postcode';
/* 개발담당:양유빈
 * 화면기능:다음 우편번호 검색
 * 세부설명:
*/

export class DaumPost extends Component {
    static displayName = DaumPost.name;

    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleComplete = this.handleComplete.bind(this);
       
    }
    //초기화
    componentDidMount() {
    }
    handleComplete = (data) => {
         
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        let Zoneode = data.zonecode;
        let Address = fullAddress;
        this.props.PostClick(Zoneode, Address);
       
    }
   

    render() {
        return (
            <div  className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id } data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <DaumPostcode
                                onComplete={this.handleComplete}
                                autoClose={ false}
                                />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
